import React from 'react'
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Styles from "../Styles/Styles";

export default function Wrapper(props: any) {
    const classes = Styles({});
    return (
        <Container>
            <div style={{padding: 15}}>
                <Grid container>
                    <Grid item md={12}>
                        <Grid container spacing={1}>
                            <Grid item md={3}>&nbsp;</Grid>
                            <Grid item md={6}>
                                <Paper className={classes.paper}>
                                    <Grid container spacing={1}>
                                        <Grid item md={2} sm={1} xs={1}>&nbsp;</Grid>
                                        <Grid item md={8} sm={10} xs={10}>
                                            {props.children}
                                        </Grid>
                                        <Grid item md={2} sm={1} xs={1}>&nbsp;</Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item md={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Container>
    );
}